import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import { Layout } from "@/components/Layout";
import { lazyImport } from "@/utils/lazyImport";

import { RouteConstant } from "./routeConstant";
import {
  Posts,
  AddPost,
  Profile,
  Chat,
  Message,
  Notification,
  AddEvent,
  Events,
  AddArticle,
  Articles,
  Friends,
} from "@/features/user";
import { UserSpinner } from "@/components/Common";
import { useChatHub } from "@/features/user/hooks/useChatHub";
import { CreateAdvert, ViewAdvert } from "@/features/merchant";
import { AdminSetting } from "@/features/admin";

const { Accounts } = lazyImport(() => import("@/features/admin"), "Accounts");
const { DeleteAccount } = lazyImport(
  () => import("@/features/admin"),
  "DeleteAccount"
);

const App = ({ isAdmin }: { isAdmin?: boolean }) => {
  return (
    <Layout isAdmin={isAdmin}>
      <Suspense fallback={<UserSpinner />}>
        <Outlet />
      </Suspense>
    </Layout>
  );
};

const UserApp = () => {
  useChatHub();

  return <App />;
};

export const protectedRoutes = [
  {
    path: RouteConstant.Admin,
    element: <App isAdmin />,
    children: [
      { path: RouteConstant.Account, element: <Accounts /> },
      { path: RouteConstant.DeleteUser, element: <DeleteAccount /> },
      { path: RouteConstant.Settings, element: <AdminSetting /> },
    ],
  },
  {
    path: RouteConstant.User,
    element: <UserApp />,
    children: [
      { path: RouteConstant.Posts, element: <Posts /> },
      { path: RouteConstant.AddPost, element: <AddPost /> },
      { path: RouteConstant.Profile, element: <Profile /> },
      { path: `${RouteConstant.Chat}/:recipientId?`, element: <Chat /> },
      { path: RouteConstant.Message, element: <Message /> },
      {
        path: `${RouteConstant.Notification}/:category`,
        element: <Notification />,
      },
      { path: RouteConstant.AddEvent, element: <AddEvent /> },
      { path: RouteConstant.Events, element: <Events /> },
      { path: RouteConstant.AddArticle, element: <AddArticle /> },
      { path: RouteConstant.Articles, element: <Articles /> },
      { path: `${RouteConstant.Friends}/:defaultTab?`, element: <Friends /> },
    ],
  },
  {
    path: RouteConstant.Merchant,
    element: <UserApp />,
    children: [
      { path: RouteConstant.CreateAdvert, element: <CreateAdvert /> },
      { path: RouteConstant.Adverts, element: <ViewAdvert /> },
    ],
  },
];
